import React, {Component} from 'react';
import {connect} from 'react-redux';

import { withRouter, NavLink} from 'react-router-dom';
import ChildUserForm from '../ChildUserForm';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { updateUser } from '../../../redux/actions/userAction';
import Settings from '../Settings';
import RepresentativeClientSettings from '../Settings/RepresentativeClientSettings';
import ReactTable from "react-table";
import "react-table/react-table.css";
import {Input} from 'reactstrap';

class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user_profile: false,
            updatePassword : false,
            errorTexts : {
                name: false,
                telephone: false,
                email: false,
                password: false,
                password_repeat: false,
            }
        }

        this.updateField = this.updateField.bind(this);
    }
    updateEmail(e) {
        this.setState({
            user_email: e.target.value
        });
    }

    updateField(e, isRequired, sameAs = false) {
        let errorTexts = this.state.errorTexts;

        if(isRequired) {
            if(e.target.value === '') {
                errorTexts[e.target.getAttribute('name')] = "Dit veld is verplicht";
            }else{
                errorTexts[e.target.getAttribute('name')] = false;
            }
        }
        
        if(sameAs !== false) {

            let thisField = e.target.value;
            let matchField = this.state.user_profile[sameAs];

            if(thisField && matchField) {

                if(e.target.value !== matchField) {
                     errorTexts[e.target.getAttribute('name')] = "Wachtwoorden zijn ongelijk";
                     errorTexts[sameAs] = "Wachtwoorden zijn ongelijk";
                }else{
                    errorTexts[e.target.getAttribute('name')] = false;
                    errorTexts[sameAs] = false;
                }
            }else{
                if((thisField === '' && matchField === '') || (thisField === '' && matchField === undefined)) {
                    errorTexts[e.target.getAttribute('name')] = false;
                    errorTexts[sameAs] = false;
                }else{
                    errorTexts[e.target.getAttribute('name')] = "Wachtwoorden zijn ongelijk";
                    errorTexts[sameAs] = "Wachtwoorden zijn ongelijk";
                }

            }
        }

        this.setState({
            user_profile : {
                ...this.state.user_profile,
                [e.target.getAttribute('name')] : e.target.value
            },
            errorTexts
        })
    }

   

    handleSubmit(e) {
        if(e) {
            e.preventDefault();
        }

        const errors = this.state.errorTexts;
        let user_profile = this.state.user_profile;
        user_profile['user_id'] = this.state.user_id;
        let containsError = false;
        for (let key in errors) {
            if(errors.hasOwnProperty(key)) {
                if(errors[key] !== false) {
                    containsError = true;
                }
            }
        }

        if(!containsError) {
            user_profile = {
                ...user_profile,
                updatePassword : this.state.updatePassword
            }
            this.props.updateUser(this.props.clientPath + '/api/user/action/update', user_profile);
        }

    }

     setCheckedValue(e) {
        this.setState({
            user_profile : {
                ...this.state.user_profile,
                [e.target.getAttribute('name')] : e.target.checked ? 1 : 0
            }
        })
    }

    _setUpdatePassword = (e) => {

        let newUserProfile = {};

        const oldUserProfile = {...this.state.user_profile};

        for ( let key in oldUserProfile ) {
            if (oldUserProfile.hasOwnProperty(key)) {
                if ( key !== 'password' && key !== 'password_repeat') {
                    newUserProfile = {
                        ...newUserProfile,
                        [key] : oldUserProfile[key]
                    }
                }

            }
        }

        this.setState({
            ...this.state,
            user_profile : newUserProfile,
            updatePassword : !this.state.updatePassword,

            errorTexts : {
                password: false,
                password_repeat: false,
            }
        })

    }

 

    componentDidMount() {
        this.setState({
            user_profile: this.props.user.user_profile.is_representative == '1' ? this.props.user.user_profile.selectedRepresentativeProfile : this.props.user.user_profile,
            user_id: this.props.user.user_id
        })

        document.querySelector('title').innerHTML = 'MijnDP - Profiel';
    }

    render() {
        return (
            <div>
                <div className={this.props.user.user_profile.is_main_account === '1' ? "column column--6": "column column--12"}>
                    <div className="card">

                        <div className="card__header">
                          <h1>Mijn Profiel</h1>
                        </div>

                        <div className="card__body">
                            <div className="card__content">


                                        <form onSubmit={this.handleSubmit}>
                                            <TextField
                                                id="name"
                                                name="name"
                                                floatingLabelText="Naam"
                                                disabled={this.props.user.user_profile.is_main_account === '0' ? true : false}
                                                errorText={this.state.errorTexts.name}
                                                fullWidth={true}
                                                required={true}
                                                value={this.state.user_profile ? this.state.user_profile.name : ''}
                                                onChange={(e) => this.updateField(e, true)}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        this.handleSubmit()
                                                    }
                                                  }}
                                            />

                                            <TextField
                                                id="telephone"
                                                floatingLabelText="Mobiel"
                                                disabled={this.props.user.user_profile.is_main_account  === '0' ? true : false}
                                                name="telephone"
                                                fullWidth={true}
                                                errorText={this.state.errorTexts.telephone}
                                                value={this.state.user_profile ? this.state.user_profile.telephone : ''}
                                                onChange={(e) => this.updateField(e, false)}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        this.handleSubmit()
                                                    }
                                                  }}
                                            />

                                            <TextField
                                                id="email"
                                                name="email"
                                                disabled={this.props.user.user_profile.is_main_account  === '0' ? true : false}
                                                floatingLabelText="E-mailadres"
                                                value={this.state.user_profile ? this.state.user_profile.email : ''}
                                                fullWidth={true}
                                                onChange={(e) => this.updateField(e, true)}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        this.handleSubmit()
                                                    }
                                                  }}
                                            />
                                            <div className="update-password-fields">
                                                <Checkbox
                                                    id="updatePassword"
                                                    name="updatePassword"
                                                    disabled={this.props.user.user_profile.is_representative == '1' ? true : false}
                                                    floatingLabelText="Wachtwoord wijzigen"
                                                    checked={this.state.updatePassword ? true : false}

                                                    onClick={this._setUpdatePassword}

                                                />
                                                <label onClick={this._setUpdatePassword}>Wachtwoord wijzigen</label>
                                            </div>
                                            {this.state.updatePassword ?
                                                <React.Fragment>
                                                    {/*<span style={{fontSize: '12px', marginBottom : '-18px', display: 'block', marginTop: '15px'}}>Minimaal 7 tekens</span>*/}
                                                    <TextField
                                                        id="password"
                                                        name="password"
                                                        type="password"
                                                        errorText={this.state.errorTexts.password}
                                                        floatingLabelText="Wachtwoord (minimaal 7 tekens)"
                                                        fullWidth={true}
                                                        autoComplete="off"
                                                        onChange={(e) => this.updateField(e, false, 'password_repeat')}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.handleSubmit()
                                                            }
                                                          }}
                                                    />

                                                    <TextField
                                                        id="password_repeat"
                                                        name="password_repeat"
                                                        type="password"
                                                        floatingLabelText="Wachtwoord herhalen"
                                                        autoComplete="off"
                                                        errorText={this.state.errorTexts.password_repeat}
                                                        fullWidth={true}
                                                        onChange={(e) => this.updateField(e, false, 'password')}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.handleSubmit()
                                                            }
                                                          }}
                                                    />
                                                </React.Fragment>
                                                : null }
                                            <div>
                                            {
                                                this.props.user.user_profile.is_main_account === '1' ?
                                                <div className="update-password-fields">
                                                <Checkbox value='1' disabled={this.props.user.user_profile.is_representative == '1' ? true : false} defaultChecked={this.props.user.user_profile.mobile_verification == '0' ? false : true} name="mobile_verification" className="input__checkbox--search" type="checkbox"  onClick={(e) => this.setCheckedValue(e)}/>
                                                <label>Inloggen met wachtwoord én SMS-verificatie code (extra veilig, maar 06 nummer is noodzakelijk).</label>
                                            </div> : ''}
                                        </div>
                                            <div className="floating__button floating__button--right">
                                                <RaisedButton disabled={this.props.user.user_profile.is_representative == '1' ? true : false} onClick={() => this.handleSubmit()} label="Opslaan"  primary={true} fullWidth={true}/>
                                            </div>
                                        </form>



                            </div>
                        </div>
                    </div>
                    {this.props.user.user_profile.is_representative == '1' ? <RepresentativeClientSettings /> : <Settings />}
                </div>
                {this.props.user.user_profile.is_main_account === '1' ?
                <div className="column column--6--last">
                    <div className="card">
                        <div className="card__header">
                            <h1>Mijn gebruikers</h1>
                        </div>

                        <div className="card__body">
                            <div className="card__content">
                            <ReactTable
                              data={this.props.user.user_profile.is_representative == '1' ? this.props.user.user_profile.selectedRepresentativeProfile.childUsers.data ? this.props.user.user_profile.selectedRepresentativeProfile.childUsers.data : [] : this.props.user.childUsers ? this.props.user.childUsers : []}
                              showPagination={true}
                            previousText="Vorige"
                              nextText='Volgende'
                              loadingText='Laden...'
                              noDataText='Geen data gevonden'
                              pageText='Pagina'
                              ofText='van'
                              rowsText='rijen'
                              columns={[
                                    {
                                      Header: "Gebruiker",
                                      accessor: "name"
                                    },
                                    {
                                      Header: "E-mail",
                                      accessor: "email"
                                    },
                                    {
                                      Header: "Telefoon nr.",
                                      accessor: "phone"
                                    },
                                    {
                                      Header: "Is actief?",
                                      accessor: "is_active",
                                       Cell: props => <span>{props.value == '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
                                    },
                                    {
                                        Header: "#",
                                        Cell: props => <span><NavLink style={{textDecoration: 'none', color: '#0a60a7' }} to={this.props.user.user_profile.is_representative == '1' ? '#' :'/mijn-gebruikers/wijzigen/'+props.index}>Wijzigen</NavLink></span>
                                    }
                                  ]}
                                  defaultSorted={[
                                    {
                                      id: "is_active",
                                      desc: true
                                    }
                                  ]}
                              defaultPageSize={10}
                              className="-striped -highlight"
                            />

                            </div>
                        </div>


                    </div>

                    {this.props.user.user_profile.is_representative == '1' ? null : <ChildUserForm />}
                </div> : null}
            </div>
        );
    }

}

function mapStateToProps (state) {
    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateUser: (url, data) => dispatch(updateUser(url, data))
    };
};



export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile));



// WEBPACK FOOTER //
// ./src/components/User/Profile/index.js